import Vue from 'vue';
import * as types from './types';
import router from '@/router';
import commonApi from '@/apis/common';
import Api from '@/apis/authBind/index';

const initLoginForm = {
  loginType: '',
  code: '',
  phone: '',
  smscode: '',
};

const initTimeInfo = {
  timer: '',
  time: 0,
};


export default {
  namespaced: true,
  state: {
    activeStep: Number(sessionStorage.getItem('activeStep')) || 1,
    accountType: Number(sessionStorage.getItem('accountType')) || undefined,
    userForm: {
      phone: '',
      code: '',
      inviteCode: '',
      nickname: '',
    },
    mediaInfo: {
      name: '',
      type: '',
    },
    // 计时器
    timeInfo: {
      ...initTimeInfo,
    },
    // 登陆表单信息
    loginForm: {
      ...initLoginForm,
    },
    // 是否为手机登陆
    isPhone: false,
  },
  mutations: {
    [types.SET_NEXT_STEP](state) {
      state.activeStep += 1;
    },
    [types.SET_PREV_STEP](state) {
      state.activeStep -= 1;
    },
    [types.CHOOSE_NEW_ACCOUNT_TYPE](state) {
      sessionStorage.setItem('accountType', 1);
      state.accountType = 1;
    },
    [types.CHOOSE_EXIST_ACCOUNT_TYPE](state) {
      sessionStorage.setItem('accountType', 2);
      state.accountType = 2;
    },
    [types.SET_USER_FORM](state, payload = {}) {
      state.userForm = {
        ...state.userForm,
        ...payload,
      };
    },
    [types.SET_MEDIA_INFO](state, payload = {}) {
      state.mediaInfo = {
        ...state.mediaInfo,
        ...payload,
      };
    },
    // 设置登录或注册信息
    [types.SET_LOGIN_FORM](state, loginForm = initLoginForm) {
      state.loginForm = {
        ...state.loginForm,
        ...loginForm,
      };
    },
    [types.SET_TIME_INFO](state, timeInfo = initTimeInfo) {
      state.timeInfo = {
        ...state.timeInfo,
        ...timeInfo,
      };
    },
    [types.SET_IS_PHONE](state, isPhone = true) {
      state.isPhone = isPhone;
    },
  },
  actions: {
    async getMediaInfo({
      commit,
    }, {
      mediaType,
    }) {
      const reqData = { media_type_str: mediaType };
      const res = await Api.getMediaInfo(reqData, false);
      if (Number(res?.head?.code) !== 0) return;

      commit(types.SET_MEDIA_INFO, {
        name: res?.media_type_cn,
        type: res?.media_type_str,
      });
    },

    /**
     * 获取token信息
     * @param {object} store
     * @param {boolean} isPhone 创建账户时判断第一次登陆是否为手机号
     */
    async getToken({
      state,
      dispatch,
    }, isPhone = false) {
      try {
        if (state.loginForm.loginType === 'phone' && !isPhone) {
          // 校验不通过会抛出异常，不再往下执行
          await dispatch('verifySmscode');
        }

        await dispatch('loginOrRegist');
      } catch (e) {
        Vue.prototype.$message.error(e.message);
      }
    },
    async verifySmscode({
      state,
    }) {
      const {
        phone,
        smscode,
      } = state.loginForm;
      if (!phone) {
        throw new Error('请输入手机号');
      }

      if (!smscode) {
        throw new Error('请输入验证码');
      }

      const reqData = {
        phone_number: phone,
        code: smscode,
      };
      const res = await commonApi.verifySmsCode(reqData);
      const code = Number(res?.head?.code);

      if (code === 5101) {
        const errorMsg = `[${code}] 验证码错误或已过期`;
        throw new Error(errorMsg);
      };

      if (code !== 0) {
        const errorMsg = `[${code}] 短信验证码验证失败`;
        throw new Error(errorMsg);
      };
    },

    /**
     * 登录或注册中台信息
     * @param {object} store
     */
    async loginOrRegist({
      state,
      dispatch,
    }) {
      const { loginForm, activeStep, accountType } = state;
      const { loginType, code, phone } = loginForm;
      const reqData = {
        type: loginType,
        value: code || phone,
      };
      const res = await Api.loginOrRegister(reqData, false);

      const userID = res?.user_id;
      if (userID !== undefined) {
        // 防止创建新账户登陆覆盖之前登陆信息
        if (accountType !== 1 || activeStep !== 2) {
          sessionStorage.setItem('registerUserId', userID);
        }

        // 登录成功后校验是否绑定媒体账户
        await dispatch('checkBindAccount', res);
        return;
      }

      const resCode = Number(res?.head?.code);
      if (resCode !== 0) {
        const errorMsg = `[${resCode}] 请求失败：${res?.head?.msg}`;
        throw new Error(errorMsg);
      }
    },

    /**
     * 判断是否绑定媒体账户
     * @param {object} store
     * @param {object} userInfo 登录后的信息
     */
    async checkBindAccount({
      state,
      commit,
      dispatch,
    }, userInfo) {
      const { loginForm, activeStep, accountType, timeInfo } = state;
      const mediaType = sessionStorage.getItem('mediaType');

      if (Number(userInfo.uid) === 0) {
        if (accountType === 1 && activeStep === 2) {
          await dispatch('registAndBindAccount');

          // 绑定后重新登入刷新 token
          const { loginType, code, phone } = loginForm;
          const reqData = {
            type: loginType,
            value: code || phone,
          };
          await Api.loginOrRegister(reqData);
          commit(types.SET_NEXT_STEP);
        } else {
          router.push(`/authBind/${mediaType}/process`);
        }

        return;
      }

      const profile = await dispatch('userCenter/fetchCpProfile', {}, {
        root: true,
      });

      const isConfirm = await Vue.prototype.$myDialog({
        text: `您已有电商管理平台账号${profile.nickname}，是否直接关联？`,
        confirmBtnText: '关联',
        cancelBtnText: '不关联',
        noCloseButton: true,
      });

      if (!isConfirm) {
        // 清空数据
        clearInterval(timeInfo.timer);
        commit(types.SET_TIME_INFO);
        commit(types.SET_LOGIN_FORM);

        if (loginForm.loginType === 'phone') {
          throw new Error('请您更换手机号');
        }

        throw new Error('请更换登录方式');
      }

      if (accountType === 1 && activeStep === 2) {
        // 通过媒体id注册中台账户并绑定
        await dispatch('registAndBindAccount');
      } else {
        // 通过媒体id与中台账户绑定
        await dispatch('bindMediaAccount');
      }

      // 跳转结果页
      await dispatch('userCenter/fetchCpProfile', {}, {
        root: true,
      });

      router.push(`/authBind/${mediaType}/result`);
    },

    /**
     * 绑定媒体账户
     */
    async bindMediaAccount() {
      const mediaType = sessionStorage.getItem('mediaType');
      const mediaId = sessionStorage.getItem('mediaId');
      const queryData = sessionStorage.getItem('queryData');
      const reqData = {
        media_type_str: mediaType,
        media_id: mediaId,
        data: queryData,
      };
      // 账户绑定媒体，成功后跳转到绑定结果页面
      const res = await Api.bindMedia(reqData, false);
      const code = Number(res?.head?.code);

      if (code !== 0) {
        const errorMsg = `[${code}] 绑定媒体账号失败：${res?.head?.msg}`;
        throw new Error(errorMsg);
      }
    },

    async registAndBindAccount({
      state,
    }) {
      const {
        loginForm,
        mediaInfo,
      } = state;
      const registerUserId = sessionStorage.getItem('registerUserId');
      const mediaId = sessionStorage.getItem('mediaId');
      const queryData = sessionStorage.getItem('queryData');

      const reqData = {
        phone: loginForm.phone,
        media_type: mediaInfo.type,
        register_user_id: registerUserId,
        media_id: mediaId,
        data: queryData,
      };
      const res = await Api.registerAndBindAccount(reqData, false);
      const resCode = Number(res?.head?.code);

      if (resCode !== 0) {
        const errorMsg = `[${resCode}] 绑定失败：${res?.head?.msg}`;
        throw new Error(errorMsg);
      }
    },
  },
};
